import React from 'react';
import PropTypes from 'prop-types';
import { BranchShape } from '../../../utils';

const BranchResult = (props) => {
  const {
    branch: { name },
    onClick,
    children,
  } = props;

  return (
    <div className="branch-result" onClick={onClick}>
      <span className="branch-result__name">{name}</span>
      {children}
    </div>
  );
};

BranchResult.propTypes = {
  branch: BranchShape,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any,
};

export default BranchResult;
